export const copyExp = {
  es: {
    ui: {
      home: "Inicio",
      services: "Servicios",
      pricing: "Precios",
      work: "Casos",
      about: "Nosotros",
      insights: "Recursos",
      contact: "Contacto",
      letsTalk: "Hablemos",
      readMore: "Leer artículo",
      minRead: "min de lectura",
      faq: "Preguntas frecuentes",
      includes: "Qué incluye",
      related: "Servicios relacionados",
      allServices: "Ver todos los servicios",
      viewPlans: "Ver planes y precios",
      backToBlog: "Volver a recursos",
      explore: "Explorar",
      menu: "Menú",
    },
    wa: {
      web: "Hola Devoluzion 👋 Quiero cotizar una página web para mi empresa.",
      ai: "Hola Devoluzion 👋 Quiero implementar IA en mi empresa y necesito orientación.",
      software: "Hola Devoluzion 👋 Necesito desarrollar un software para mi empresa.",
      ecommerce: "Hola Devoluzion 👋 Quiero crear o mejorar mi ecommerce.",
      p360: "Hola Devoluzion 👋 Me interesa DEVOLUZION 360 y quiero saber cómo pueden ayudar a transformar digitalmente mi empresa.",
      automation: "Hola Devoluzion 👋 Quiero automatizar procesos de mi empresa.",
      growth: "Hola Devoluzion 👋 Quiero hacer crecer mi empresa con marketing digital.",
      general: "Hola Devoluzion 👋 Quiero conversar sobre mi proyecto.",
    },
    cta: {
      web: "Quiero una web como esta",
      ai: "Implementar IA",
      software: "Construir mi software",
      automation: "Automatizar mi empresa",
      ecommerce: "Crear mi Ecommerce",
      growth: "Quiero crecer",
      talk: "Hablar con Devoluzion",
    },
    hub: {
      kicker: "SERVICIOS",
      h1: "TODO LO QUE TU EMPRESA NECESITA PARA EVOLUCIONAR.",
      sub: "Diseño, tecnología, inteligencia artificial, automatización y growth trabajando como un solo ecosistema.",
      title: "Servicios — DEVOLUZION",
      desc: "Diseño web, desarrollo de software, ecommerce, automatización, agentes de IA y marketing digital. Un solo ecosistema para hacer evolucionar tu empresa.",
    },
    pricing: {
      kicker: "PRECIOS",
      h1: "ELIGE HASTA DÓNDE QUIERES EVOLUCIONAR.",
      sub: "Soluciones diseñadas para empresas que quieren dar el siguiente paso digital.",
      title: "Precios y Planes — DEVOLUZION",
      desc: "Planes DEVOLUZION START, AI, COMMERCE y 360. Precios claros en CLP y USD para hacer evolucionar tu empresa.",
      recommended: "RECOMENDADO",
      from: "DESDE",
      taxes: "+ impuestos",
      intl: "Mercado internacional:",
      perProject: "El valor final depende del alcance del proyecto.",
      disclaimer: "Los valores corresponden a configuraciones iniciales y pueden variar según alcance, integraciones, funcionalidades, infraestructura, licencias y requerimientos específicos del proyecto.",
      flowTitle: "Así funciona DEVOLUZION 360",
      plans: [
        {
          id: "start",
          name: "DEVOLUZION START",
          price: "$149.990 CLP",
          intl: "USD 149 + impuestos aplicables",
          desc: "Para empresas que necesitan modernizar su presencia digital.",
          features: ["Web premium", "UX/UI", "Responsive", "SEO técnico inicial", "Analytics", "Google Search Console", "WhatsApp", "Formulario", "Automatización básica"],
          cta: "Comenzar con START",
          wa: "web",
        },
        {
          id: "ai",
          name: "DEVOLUZION AI",
          price: "$299.990 CLP",
          intl: "USD 299 + impuestos aplicables",
          desc: "Para empresas que quieren comenzar a utilizar inteligencia artificial.",
          features: ["Diagnóstico", "Oportunidades IA", "Agente de IA", "Automatización", "Integración", "Configuración", "Capacitación", "Roadmap"],
          cta: "Quiero comenzar con IA",
          wa: "ai",
        },
        {
          id: "commerce",
          name: "DEVOLUZION COMMERCE",
          price: "$499.990 CLP",
          intl: "USD 499 + impuestos aplicables",
          desc: "Para negocios listos para convertir su canal digital en un canal de ventas.",
          features: ["Ecommerce", "UX/UI", "Pagos", "Analytics", "CRM básico", "Automatización", "SEO inicial", "Integraciones", "Conversión"],
          cta: "Crear mi Ecommerce",
          wa: "ecommerce",
        },
        {
          id: "p360",
          name: "DEVOLUZION 360",
          price: "DESDE $699.990 CLP",
          intl: "Desde USD 699 + impuestos aplicables",
          headline: "Ten la IA en tus manos.",
          desc: "Una experiencia de transformación digital diseñada para empresarios que quieren entender, implementar y aprovechar las nuevas tecnologías dentro de su empresa.",
          features: ["Diagnóstico digital", "Estrategia", "Web", "IA", "Agentes IA", "Automatización", "Software", "Marketing", "Data", "Growth", "Capacitación", "Roadmap tecnológico"],
          flow: ["DESCUBRIR", "ENTENDER", "IMPLEMENTAR", "AUTOMATIZAR", "MEDIR", "CRECER"],
          cta: "Quiero DEVOLUZION 360",
          wa: "p360",
        },
      ],
    },
    blog: {
      kicker: "RECURSOS",
      h1: "Ideas para evolucionar.",
      sub: "Guías claras sobre IA, web, software, automatización y marketing digital — escritas para tomar decisiones, no para impresionar.",
      title: "Recursos e Ideas — DEVOLUZION",
      desc: "Guías sobre agentes de IA, desarrollo web, software a medida, automatización y marketing digital para empresas en Chile y Latinoamérica.",
    },
    about: {
      kicker: "NOSOTROS",
      h1: "No digitalizamos empresas.",
      h1b: "Las hacemos evolucionar.",
      p1: "DEVOLUZION nació de una frustración: empresas con enorme potencial operando con herramientas digitales mediocres. Websites lentos, procesos manuales, datos dispersos y decisiones a ciegas.",
      p2: "No somos una agencia que hace un poco de todo. Somos una empresa de evolución digital: web, ecommerce, software, automatización, IA, data y growth funcionando como un solo ecosistema, con un solo estándar: que se note en los resultados.",
      p3: "Trabajamos desde Chile — La Serena, Santiago y Concepción — para empresas que quieren competir con la tecnología de las grandes, sin perder la cercanía de un equipo que responde.",
      valuesTitle: "Cómo trabajamos",
      values: [
        { t: "Criterio sobre moda", d: "No implementamos tecnología porque está de moda. La usamos donde genera impacto medible." },
        { t: "Ingeniería con diseño", d: "El código y la estética no son departamentos separados: son la misma obsesión." },
        { t: "Datos antes que opiniones", d: "Cada decisión se mide. Lo que no se mide, no evoluciona." },
        { t: "Socios, no proveedores", d: "Tu crecimiento es nuestra métrica de éxito. Simple." },
      ],
      locationsTitle: "Dónde estamos",
      title: "Nosotros — DEVOLUZION",
      desc: "DEVOLUZION es una empresa de evolución digital con base en Chile: web, software, IA, automatización y growth en un solo ecosistema.",
    },
    contactPage: {
      title: "Contacto — DEVOLUZION",
      desc: "Hablemos de la evolución digital de tu empresa. Respondemos en menos de 24 horas. WhatsApp +56 9 3560 9185.",
    },
    serviceUi: {
      whatWeDo: "Qué hacemos",
      howItHelps: "Qué gana tu empresa",
      process: "Cómo lo hacemos",
      deliverables: "Entregables",
    },
  },
  en: {
    ui: {
      home: "Home",
      services: "Services",
      pricing: "Pricing",
      work: "Work",
      about: "About",
      insights: "Insights",
      contact: "Contact",
      letsTalk: "Let's talk",
      readMore: "Read article",
      minRead: "min read",
      faq: "Frequently asked questions",
      includes: "What's included",
      related: "Related services",
      allServices: "View all services",
      viewPlans: "View plans & pricing",
      backToBlog: "Back to insights",
      explore: "Explore",
      menu: "Menu",
    },
    wa: {
      web: "Hi Devoluzion 👋 I'm interested in building a premium website for my business.",
      ai: "Hi Devoluzion 👋 I'd like to explore how AI could be implemented in my business.",
      software: "Hi Devoluzion 👋 I'm interested in developing custom software for my company.",
      ecommerce: "Hi Devoluzion 👋 I'd like to build or improve my ecommerce platform.",
      p360: "Hi Devoluzion 👋 I'm interested in DEVOLUZION 360 and would like to discuss the digital transformation of my business.",
      automation: "Hi Devoluzion 👋 I'd like to automate processes in my business.",
      growth: "Hi Devoluzion 👋 I want to grow my business with digital marketing.",
      general: "Hi Devoluzion 👋 I'd like to talk about my project.",
    },
    cta: {
      web: "Build a Website Like This",
      ai: "Implement AI",
      software: "Build My Software",
      automation: "Automate My Business",
      ecommerce: "Build My Ecommerce",
      growth: "Grow My Business",
      talk: "Talk to Devoluzion",
    },
    hub: {
      kicker: "SERVICES",
      h1: "EVERYTHING YOUR BUSINESS NEEDS TO EVOLVE.",
      sub: "Design, technology, artificial intelligence, automation and growth working as one connected ecosystem.",
      title: "Services — DEVOLUZION",
      desc: "Web design, software development, ecommerce, automation, AI agents and digital marketing. One ecosystem to evolve your business.",
    },
    pricing: {
      kicker: "PRICING",
      h1: "CHOOSE HOW FAR YOU WANT TO EVOLVE.",
      sub: "Digital solutions built for companies ready for their next stage of growth.",
      title: "Pricing & Plans — DEVOLUZION",
      desc: "DEVOLUZION START, AI, COMMERCE and 360 plans. Transparent pricing in USD to evolve your business.",
      recommended: "RECOMMENDED",
      from: "FROM",
      taxes: "+ applicable taxes",
      intl: "Chile:",
      perProject: "Final pricing depends on project scope.",
      disclaimer: "Prices correspond to initial configurations and may vary depending on project scope, integrations, functionality, infrastructure, licenses and specific requirements.",
      flowTitle: "How DEVOLUZION 360 works",
      plans: [
        {
          id: "start",
          name: "DEVOLUZION START",
          price: "USD 149",
          intl: "CLP $149.990 + impuestos",
          desc: "For businesses that need to modernize their digital presence.",
          features: ["Premium website", "UX/UI", "Responsive design", "Technical SEO setup", "Analytics", "Google Search Console", "WhatsApp integration", "Contact forms", "Basic automation"],
          cta: "Start with DEVOLUZION START",
          wa: "web",
        },
        {
          id: "ai",
          name: "DEVOLUZION AI",
          price: "USD 299",
          intl: "CLP $299.990 + impuestos",
          desc: "For companies ready to start using artificial intelligence in practical business scenarios.",
          features: ["Assessment", "AI opportunities", "AI agent", "Automation", "Integration", "Setup", "Training", "Roadmap"],
          cta: "Start with AI",
          wa: "ai",
        },
        {
          id: "commerce",
          name: "DEVOLUZION COMMERCE",
          price: "USD 499",
          intl: "CLP $499.990 + impuestos",
          desc: "For businesses ready to turn digital channels into sales channels.",
          features: ["Ecommerce", "UX/UI", "Payments", "Analytics", "Basic CRM", "Automation", "Initial SEO", "Integrations", "Conversion"],
          cta: "Build my Ecommerce",
          wa: "ecommerce",
        },
        {
          id: "p360",
          name: "DEVOLUZION 360",
          price: "FROM USD 699",
          intl: "Desde CLP $699.990 + impuestos",
          headline: "Put AI in your hands.",
          desc: "A guided digital transformation experience for business owners who want to understand, implement and use the technologies changing how companies operate and grow.",
          features: ["Digital assessment", "Strategy", "Web", "AI", "AI agents", "Automation", "Software", "Marketing", "Data", "Growth", "Training", "Technology roadmap"],
          flow: ["DISCOVER", "UNDERSTAND", "IMPLEMENT", "AUTOMATE", "MEASURE", "GROW"],
          cta: "Start DEVOLUZION 360",
          wa: "p360",
        },
      ],
    },
    blog: {
      kicker: "INSIGHTS",
      h1: "Ideas to evolve.",
      sub: "Clear guides on AI, web, software, automation and digital marketing — written to help you decide, not to impress.",
      title: "Insights — DEVOLUZION",
      desc: "Guides on AI agents, web development, custom software, automation and digital marketing for growing businesses.",
    },
    about: {
      kicker: "ABOUT US",
      h1: "We don't just digitalize businesses.",
      h1b: "We evolve them.",
      p1: "DEVOLUZION was born out of a frustration: companies with enormous potential running on mediocre digital tools. Slow websites, manual processes, scattered data and blind decisions.",
      p2: "We're not an agency that does a bit of everything. We're a digital evolution company: web, ecommerce, software, automation, AI, data and growth working as one ecosystem, with a single standard: it has to show in the results.",
      p3: "We work from Chile — La Serena, Santiago and Concepción — for companies that want to compete with big-company technology without losing the closeness of a team that actually answers.",
      valuesTitle: "How we work",
      values: [
        { t: "Judgment over hype", d: "We don't implement technology because it's trendy. We use it where it creates measurable impact." },
        { t: "Engineering with design", d: "Code and aesthetics aren't separate departments: they're the same obsession." },
        { t: "Data before opinions", d: "Every decision is measured. What isn't measured, doesn't evolve." },
        { t: "Partners, not vendors", d: "Your growth is our success metric. Simple." },
      ],
      locationsTitle: "Where we are",
      title: "About — DEVOLUZION",
      desc: "DEVOLUZION is a digital evolution company based in Chile: web, software, AI, automation and growth in one ecosystem.",
    },
    contactPage: {
      title: "Contact — DEVOLUZION",
      desc: "Let's talk about your company's digital evolution. We reply within 24 hours. WhatsApp +56 9 3560 9185.",
    },
    serviceUi: {
      whatWeDo: "What we do",
      howItHelps: "What your business gains",
      process: "How we do it",
      deliverables: "Deliverables",
    },
  },
};
